import React from "react";

import CertificationReport from "./pages/CertificationReport/CertificationReport";
import Cleaning from "./pages/Cleaning/Cleaning";
import ExecutiveSummary from "./pages/ExecutiveSummary/ExecutiveSummary";
import HomeComponent from "./pages/Home/Home";
import Resolving from "./pages/Resolving/Resolving";
import SavePending from "./pages/SavePending/SavePending";
import Scanning from "./pages/Scanning/Scanning";
import ViewCases from "./pages/ViewCases/ViewCases";

export const privateRoutes = [
  {
    path: "/",
    element: <HomeComponent refreshTrigger={0} onRefreshMatches={() => {}} />,
  },
  { path: "/executive-summary", element: <ExecutiveSummary /> },
  { path: "/scanning", element: <Scanning /> },
  { path: "/resolving", element: <Resolving /> },
  { path: "/save-pending", element: <SavePending /> },
  { path: "/view-cases", element: <ViewCases /> },
  { path: "/certification-report", element: <CertificationReport /> },
  { path: "/cleaning", element: <Cleaning /> },
];
